import * as R from 'ramda'

/**
 * @description: 当值为null或undefined时，返回一个空数组
 * @return {*}
 */
export const createArrayWhenIsNil: <T>(value: T) => T = R.when(
  R.isNil,
  R.always([]),
)

/**
 * @description: 根据地址`data.records`到对象里面查找数据 同：lodash.get
 * @param {string} path 查找地址
 * @param {unknown} data 被查找的对象
 * @return {unknown}
 */
export const get = (path: string, data: unknown): unknown =>
  R.pipe(R.split('.'), R.path)(path)(data)

/**
 * @description: 如果参数不是 null、undefined 或 NaN，则返回参数，否则返回空字符串。
 * @return {*}
 */
export const defaultEmptyString = R.defaultTo('')

export const createDictFromArray = R.map((item: string) => ({
  label: item,
  value: item,
}))

export const createDictFromObject = R.pipe(
  R.toPairs,
  R.map(
    ([key, value]): Dict<any> => ({
      label: key,
      value,
    }),
  ),
)

export const objectToString = Object.prototype.toString
export const toTypeString = (value: unknown): string =>
  objectToString.call(value)

// 将一级对象的键按 . 分割并转换成多层级对象
export const transformToNestedObject = (
  obj: Record<string, any>,
): Record<string, any> => {
  return R.reduce(
    (acc, key) => R.assocPath(key.split('.'), obj[key], acc),
    {},
    R.keys(obj),
  )
}
